/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */
/* eslint-disable no-param-reassign */
import React, {
    useRef, useState,
} from 'react';
import {
    array,
    bool,
    func,
    object,
} from 'prop-types';
import { useUIDSeed } from 'react-uid';
import { Paper } from '@material-ui/core';
import Slider from 'react-slick';

const GraphqlUpdateProductImageSlider = ({
    classes,
    containerRef,
    altImageArray,
    track,
    trackSwipe,
    isProductNameOnOverlay,
    slider,
    productNameContainer,
    setEnableZoom,
    renderSnipeImage,
    productImageV2Block,
    isPdpRedesignEnabled,
    showProductTitleTop,
}) => {
    const seed = useUIDSeed();
    const swipeStartTimeRef = useRef(null);
    const swipeStartXRef = useRef(null);
    const swipeStartYRef = useRef(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const handleSwipeStart = (event) => {
        swipeStartTimeRef.current = new Date().getTime();
        swipeStartXRef.current = event?.touches?.[0]?.pageX || 0;
        swipeStartYRef.current = event?.touches?.[0]?.pageY || 0; // Track the initial Y position
    };
    const handleSwipeEnd = (event) => {
        const swipeEndTime = new Date().getTime();
        const swipeEndX = event.changedTouches[0]?.pageX || 0;
        const swipeEndY = event.changedTouches[0]?.pageY || 0; // Track the final Y position
        const swipeDistanceX = swipeStartXRef.current - swipeEndX;
        const swipeDistanceY = swipeStartYRef.current - swipeEndY; // Calculate the vertical swipe distance
        const horizontalThreshold = 30; // Swipe threshold for horizontal slide change
        if (Math.abs(swipeDistanceX) > Math.abs(swipeDistanceY) && Math.abs(swipeDistanceX) > horizontalThreshold) {
            if (swipeDistanceX > 0 && currentSlide < altImageArray.length - 1) {
                trackSwipe('Swipe Left');
                slider.current.slickNext();
            } else if (swipeDistanceX < 0 && currentSlide > 0) {
                trackSwipe('Swipe Right');
                slider.current.slickPrev();
            }
        } else {
            // Reset to the current slide if swipe is too short
            slider.current.slickGoTo(currentSlide);
        }
        // Clean up
        swipeStartTimeRef.current = null;
        swipeStartXRef.current = null;
        swipeStartYRef.current = null;
    };
    const handleAfterChange = (current) => {
        setCurrentSlide(current);
        track(current);
    };
    let rootContainer = '';
    if (showProductTitleTop) {
        rootContainer = `${classes.rootWrapper} ${classes.sliderWrapper}`;
    } else if (isPdpRedesignEnabled) {
        rootContainer = `${classes.rootWrapper}`;
    }
    const handleBeforeChange = () => {
        if (slider.current) {
            slider.current.innerSlider.list.style.transition = ''; // Ensure default transition is restored
            slider.current.innerSlider.list.style.transform = ''; // Clear manual transform
        }
    };

    return (
        <>
            <Paper
                ref={containerRef}
                className={`${classes.root} ${rootContainer}`}
                onTouchStart={handleSwipeStart}
                onTouchEnd={handleSwipeEnd}
                onPointerDown={() => setEnableZoom(true)}
                onPointerMove={() => setEnableZoom(false)}
                onPointerUp={() => renderSnipeImage(true)}
            >
                <Slider
                    dots
                    accessibility
                    speed={75}
                    infinite={false}
                    slidesToShow={1}
                    slidesToScroll={1}
                    arrows={false}
                    cssEase="ease-out"
                    ref={slider}
                    className={`carousel-container ${productImageV2Block ? classes.carouselContainer : classes.pdpCarouselContainer} ${isProductNameOnOverlay && altImageArray.length > 1 ? classes.slickOverlay : ''} ${altImageArray.length > 1 ? classes.pdpAltScrollBar : ''}`}
                    dotsClass="slick-dots slick-thumb"
                    customPaging={(i) => <div className={productImageV2Block ? classes.dotNavigation : classes.pdpDotNavigation} aria-label={`Image ${i + 1}`} />}
                    afterChange={handleAfterChange}
                    beforeChange={handleBeforeChange}
                >
                    {altImageArray?.map((item) => (
                        <div key={seed(item)}>
                            {item}
                        </div>
                    ))}
                </Slider>
                {!showProductTitleTop && productNameContainer()}
            </Paper>
        </>
    );
};

GraphqlUpdateProductImageSlider.propTypes = {
    classes: object.isRequired,
    altImageArray: array.isRequired,
    isProductNameOnOverlay: bool,
    track: func,
    trackSwipe: func,
    containerRef: func,
    slider: object,
    productNameContainer: func,
    renderSnipeImage: func,
    setEnableZoom: func,
    productImageV2Block: bool,
    isPdpRedesignEnabled: bool,
    showProductTitleTop: bool,
};

GraphqlUpdateProductImageSlider.defaultProps = {
    isProductNameOnOverlay: false,
    track: () => {},
    trackSwipe: () => {},
    containerRef: () => {},
    slider: () => {},
    productNameContainer: () => {},
    renderSnipeImage: () => {},
    setEnableZoom: () => {},
    productImageV2Block: false,
    isPdpRedesignEnabled: false,
    showProductTitleTop: false,

};

export default GraphqlUpdateProductImageSlider;
